import { doc, runTransaction } from "firebase/firestore";
import dayjs from "dayjs";


async function saveVersion(db, user, environment, platform, ver) {
    console.debug("🗄️ SAVEVERSION");
    const currentUserRef = doc(db, "user", user);

    const currentDate = dayjs();
    const formattedDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

    await runTransaction(db, async (transaction) => {
        await transaction.get(currentUserRef).then((doc) => { 
            let u = doc; 

            if (!u.exists) {
                throw "Document does not exist!";
            }

            var newUser = u.data();

            if (newUser.versions) {
              let versions = newUser.versions;
              if (!versions[environment]) {
                versions[environment] = [];
              }
              // Check if an entry for this platform already exists
              let existingIndex = -1;
              for (let i = 0; i < versions[environment].length; i++) {
                if (versions[environment][i].platform === platform) {
                  existingIndex = i;
                  break;
                }
              }
              if (existingIndex !== -1) {
                // Replace existing entry
                versions[environment][existingIndex] = { "date": formattedDate, "platform": platform, "ver": ver};
              } else {
                // Add new entry
                versions[environment].push({ "date": formattedDate, "platform": platform, "ver": ver});
              }
              newUser.versions = versions;
            } else {
              let versions = {};
              versions[environment] = [];
              versions[environment].push({ "date": formattedDate, "platform": platform, "ver": ver});
              newUser.versions = versions;
            }
            console.debug("🗄️ %o", newUser);

            transaction.update(currentUserRef, newUser);

        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
    }).catch((err) => {
        console.error(err);
    });
  }

export { saveVersion };